import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type SelectionType = 'Home' | 'Draw' | 'Away'
export type Selections = Record<string, Selection>

const initialState: TippingState = {
  selections: {},
}

const tippingSlice = createSlice({
  name: 'tipping',
  initialState,
  reducers: {
    toggleSelectionForGame(state, action: PayloadAction<ToggleSelectionPayload>) {
      const { gameId, selectionType } = action.payload
      const currentSelection = state.selections[gameId]

      if (currentSelection) {
        switch (selectionType) {
          case 'Home':
            currentSelection.isHome = !currentSelection.isHome
            break
          case 'Draw':
            currentSelection.isDraw = !currentSelection.isDraw
            break
          case 'Away':
            currentSelection.isAway = !currentSelection.isAway
            break
        }
      } else {
        state.selections[gameId] = {
          isHome: selectionType === 'Home',
          isDraw: selectionType === 'Draw',
          isAway: selectionType === 'Away',
        }
      }
    },

    clearToteSportSelections() {
      return initialState
    },
  },
})

export const { toggleSelectionForGame, clearToteSportSelections } = tippingSlice.actions

export default tippingSlice.reducer

// =====
// Types
// =====

type TippingState = {
  selections: Selections
}

type ToggleSelectionPayload = {
  gameId: string
  selectionType: SelectionType
}

type Selection = {
  isHome: boolean
  isAway: boolean
  isDraw: boolean
}
